import React from 'react';

function NetworkQualityBars({ level }) {
  const maxLevel = 5; // Total 5 levels (0-4)
  const baseHeight = 4; // Base height for the smallest bar

  // Calculate the height of each bar based on its index
  const barStyles = (index) => ({
    height: `${baseHeight * (index + 1)}px`, // Each bar is progressively taller
    backgroundColor: index < level ? 'green' : '#ccc',
    width: '6px', // Narrower bars for a more compact design
    marginLeft: '2px', // Reduced space between bars
    transition: 'background-color 0.3s ease' // Smooth transition for color change
  });

  return (
    <div style={{ display: 'flex', alignItems: 'flex-end',marginLeft:'4px' }}>
      {[...Array(maxLevel)].map((_, i) => (
        <div key={i} style={barStyles(i)} />
      ))}
    </div>
  );
}

export default NetworkQualityBars;
